import {
  ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, OnChanges, OnDestroy, OnInit,
  Output, PLATFORM_ID, ViewChild, ViewEncapsulation
} from '@angular/core';

import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { isPlatformBrowser, NgTemplateOutlet, NgClass } from '@angular/common';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateModule } from '@ngx-translate/core';

import {
  PositionEnum, SdAccordionComponent, SdAccordionGroupComponent, SdBorderWrapperComponent, SdButtonComponent, SdFormInputComponent
} from '@seb/web-design-system/core';

@Component({
  selector: 'sd-single-input',
  templateUrl: './single-input.component.html',
  styleUrls: ['./single-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    SdAccordionGroupComponent,
    SdAccordionComponent,
    NgTemplateOutlet,
    SdBorderWrapperComponent,
    FormsModule,
    ReactiveFormsModule,
    NgClass,
    SdFormInputComponent,
    SdButtonComponent,
    TranslateModule
  ]
})
export class SdSingleInputComponent implements OnInit, OnChanges, OnDestroy {
  protected readonly destroy$: Subject<void> = new Subject();

  constructor(
    private formBuilder: FormBuilder,
    @Inject(PLATFORM_ID) private platformId: any,
  ) {}

  positionEnum = PositionEnum;
  accordionOpen = false;
  formAddAction: FormGroup;
  isSubmitted = false;

  @Input()
  titleLevel = 4;

  @Input()
  isAccordion = false;

  /**
   * Is the code valid
   */
  @Input()
  validate: boolean;

  /**
   * The actual code
   */
  @Input()
  code = '';

  /**
   * The actual description  code
   */
  @Input()
  description: string;
  /**
   * The input type
   */
  @Input()
  type: string;

  @Output()
  addAction = new EventEmitter<string>();

  @Output()
  deleteAction = new EventEmitter<void>();

  @Output()
  updateAction = new EventEmitter<string>();

  @ViewChild('SingleInput', { static: false })
  inputAction: SdFormInputComponent;

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.accordionOpen = this.validate;
      this.formAddAction = this.formBuilder.group({
        formInput: new FormControl({
          value: this.code,
          disabled: this.validate
        })
      });
    }
    this.formAddAction.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((form) => {
        this.updateAction.emit(form.formInput);
      });
  }

  ngOnChanges() {
    if (this.formAddAction) {
      this.formAddAction.controls['formInput'].setValue(this.code);
      if (this.validate) {
        setTimeout(() => {
          this.formAddAction.controls['formInput'].disable();
        }, 500);
      } else {
        this.formAddAction.controls['formInput'].enable();
      }
    }
  }

  submitAction() {
    this.isSubmitted = true;
    this.addAction.emit(this.inputAction.input.nativeElement.value);
  }

  delete() {
    this.isSubmitted = false;
    this.deleteAction.emit();
    this.validate = false;
    this.formAddAction.controls['formInput'].enable();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
